import defined from './defined';

export default function isTransparent(color) {
    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/is-transparent.js
// module id = 1335
// module chunks = 0